import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import { ApiService } from '@/services/api.service';

// Worker is copied to the output directory by copy-webpack-plugin (see vue.config.js)
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.BASE_URL || '/'}pdf.worker.min.js`;

const initialState = () => ({
  pdf: null,
  pdfScale: 100,
  pdfScaleValues: [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500],
  loadingTask: null,
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
    pendingRendering: true,
    renderingCompleted: false,
  },
});

let state = initialState();

const actions = {
  setPdfUrl({ commit, state }, { pdfUrl }) {
    commit('SET_PDF_URL');

    if (!pdfUrl) {
      commit('SET_PDF_URL_SUCCESS', null);
      return null;
    }

    // A file of the API: the session token in the Authorization header, as axios sends it
    const loadingTask = pdfjsLib.getDocument({ url: pdfUrl, httpHeaders: ApiService.authorizationHeader() });
    commit('SET_LOADING_TASK', loadingTask);

    loadingTask.promise
      .then((pdf) => {
        commit('SET_PDF_URL_SUCCESS', pdf);
        commit('RENDERING_SUCCESS_DONE');
        commit('SET_LOADING_TASK', null);
      })
      .catch((error) => {
        commit('SET_LOADING_TASK', null);
        commit('SET_PDF_URL_ERROR', error);
        throw error;
      });

    commit('SET_LOADING_TASK', loadingTask);
  },
  setPdfScale({ commit }, scale) {
    commit('SET_PDF_SCALE', scale);
  },
  RESET({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  SET_LOADING_TASK(state, loadingTask) {
    state.loadingTask = loadingTask;
  },
  SET_PDF_SCALE(state, scale) {
    state.pdfScale = scale;
  },
  SET_PDF_URL(state) {
    state.status = {
      ...state.status,
      pending: true,
      pendingRendering: true,
      renderingCompleted: false,
      resolved: false,
    };
  },
  SET_PDF_URL_SUCCESS(state, pdf) {
    state.status = {
      ...state.status,
      pending: false,
      pendingRendering: false,
      renderingCompleted: false,
      resolved: true,
    };
    state.pdf = pdf;
  },
  SET_PDF_URL_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      pendingRendering: true,
      renderingCompleted: false,
      rejected: true,
      error: error,
    };
  },
  RENDERING_SUCCESS_DONE(state) {
    state.status = {
      ...state.status,
      pending: false,
      pendingRendering: false,
      renderingCompleted: true,
    };
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      if (key !== 'loadingTask') {
        state[key] = initial[key];
      }
    });
  },
};

const getters = {
  pdf: (state) => state.pdf,
  pdfScale: (state) => state.pdfScale,
  pdfScaleValues: (state) => state.pdfScaleValues,
  loadingTask: (state) => state.loadingTask,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  pendingRendering: (state) => state.status.pendingRendering,
  renderingCompleted: (state) => state.status.renderingCompleted,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const pdfData = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
